import React from "react";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {UserAccountContext} from "../../../../contexts/userAccount";

export default function AddButton({to, disabled}) {
  return (
    <UserAccountContext.Consumer>
      {({user}) => {
        if (!user.permissions.edit.resources) {
          return null;
        }

        return (
          <Link to={to} disabled={disabled} className="addLink">
            <IconButton className="placebarButton placebarAddButton" disabled={disabled}>
              <FontAwesomeIcon icon={faPlus} className="placebarButtonIcon" />
            </IconButton>
          </Link>
        );
      }}
    </UserAccountContext.Consumer>
  );
}

AddButton.propTypes = {
  to: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/Placebar/components/PlacebarMenu/AddButton.jsx